import service from '@/utils/server';

const modName='/report/diamondReport/';
//查询方法
export const pageInfo = data => {
  console.log('pageInfo', '-----');
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};
//初始化页面对象
export const initPage = data => {
  return service({
    url: modName + 'initPage',
    method: 'post',
    data
  });
};

//新增方法
export const saveData = data => {
  return service({
    url: modName + 'add',
    method: 'post',
    data
  });
};

//初始化更新对象
export const initUpdate = data => {
  return service({
    url: modName + 'initUpdate/' + data,
    method: 'post',
    data
  });
};

//修改方法
export const editData = data => {
  return service({
    url: modName + 'update',
    method: 'post',
    data
  });
};

//删除方法
export const deleteData = data => {
  return service({
    url: modName + 'delete/'+data.id,
    method: 'post',
    data
  });
};
//导出excel
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};
// 导入itr 方法
export const upload = data => {
  const config = {
    // responseType: 'blob',
    timeout: 500000, // 请求超时时间
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }
  return service({
    ...config,
    url: modName + 'upload',
    method: 'post',
    data
  })


}

//查询
export const getCustomerPackerList = data =>{
  return service({
    url: modName + 'customerPackerList',
    method: 'post',
    data
  })
}


//文件下载
export const fileDownload = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'file/'+data,
    method: 'post',
    data
  });
};

//模板下载
export const template = data => {
  let config = {
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'template/' + data.templateName,
    method: 'post',
    data
  });
};





// WEBPACK FOOTER //
// ./src/page/report/diamondReportForm/api/index.js